import { BASE_URL, GECCO_URL } from "common/constants/apiUrls";
import axios from "axios";

export const getData = async (api, gateway = BASE_URL) => {
  let url = gateway + api;
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const postData = async (api, dataObj) => {
  let url = BASE_URL + api;
  try {
    const response = await axios.post(url, dataObj);
    const { status, data } = response;
    if (status === 422) return { status, data };
    else return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const deleteData = async (api, key) => {
  let url = BASE_URL + api + key;
  try {
    const { data } = await axios.delete(url);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const updateData = async (api, dataObj) => {
  let url = BASE_URL + api;
  try {
    const { status, data } = await axios.put(url, dataObj);
    if (status === 422) return { status, data };
    else return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const patchData = async (api, dataObj) => {
  let url = BASE_URL + api;
  try {
    const { data } = await axios.patch(url, dataObj);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getDataGecco = async (api, key) => {
  let url = GECCO_URL + api;
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};
export const downloadData = async (api, gateway = BASE_URL) => {
  let url = gateway + api;
  try {
    return await axios.get(url, { responseType: "blob" });
  } catch (error) {
    return error.response?.data;
  }
};
